import { windowWidth } from './utils';

const showHideProducts = {
  filterWrap: document.querySelectorAll(
    '.jsProdWrap',
  ) as NodeListOf<HTMLElement>,

  init() {
    if (windowWidth > 1199) {
      this.toggleFilters();
    }
  },

  toggleFilters() {
    this.filterWrap.forEach((filter: HTMLElement) => {
      const singleFilters: NodeListOf<HTMLElement> =
        filter.querySelectorAll('.jsProd');
      const btns: HTMLElement | null = filter.querySelector('.jsShowMore');

      if (singleFilters.length > 4 && btns) {
        filter.classList.add('filter-less');
        if (btns.style) {
          btns.style.display = 'block';
        }
      } else if (btns && btns.style) {
        btns.style.display = 'none';
      }

      if (btns) {
        btns.addEventListener('click', () => {
          filter.classList.toggle('filter-less');
          filter.style.height = filter.classList.contains('filter-less')
            ? 'auto'
            : 'auto';

          if (btns.textContent) {
            btns.textContent = filter.classList.contains('filter-less')
              ? 'Show More +'
              : 'Show Less -';
          }
        });
      }
    });
  },
};

export default showHideProducts;
